import {
  any, boolean, date, nullable,
  object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicNotificationMask = {
  eventType: string,
  metadata: object,
  read: boolean,
  readAt: date | nullable,
  glanced: boolean,
  glancedAt: date | nullable,

  createdAt: date,
  collaborators: any,
  owner: string,
  updatedAt: date,
  processedDigest: boolean,
};
